// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseLoader__root___1L86P","wrapper":"EnterpriseLoader__wrapper___2HRde","point":"EnterpriseLoader__point___3wTKt","a":"EnterpriseLoader__a___uSgH9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseLoader/EnterpriseLoader.scss
// module id = 1015
// module chunks = 0